import ErrorDto from "./apis/ErrorDto";

export class ValidationError {
    error: ErrorDto;

    constructor(error: ErrorDto) {
        this.error = error;
    }
}